import CustomPagination from '@/platform/common/components/CustomPagination/CustomPagination';
import NoDataRow from '@/platform/common/components/NoDataRow/NoDataRow';
import { localDate } from '@/platform/lib/utils';
import { useConfirmationStore } from '@/platform/stores/useConfirmationStore';
import {
    Button,
    Container,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    Segment,
    SegmentContent,
    SegmentFooter,
    SegmentHeader,
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow,
} from '@/platform/ui';
import {
    CheckIcon,
    EllipsisVerticalIcon,
    PencilIcon,
    PlusIcon,
    TrashIcon,
    XMarkIcon,
} from '@heroicons/react/24/outline';
import { Link, router, usePage } from '@inertiajs/react';

const WebhooksIndexView = () => {
    const { auth, webhooks } = usePage().props;
    const confirm = useConfirmationStore(state => state.confirm);

    const confirmDelete = webhook =>
        confirm({
            title: 'Webhook verwijderen?',
            description: `Weet je zeker dat je de webhook voor ${webhook.event} wilt verwijderen? De webhook wordt ook in Datahub verwijderd en ontvangt geen events meer.`,
            confirmLabel: 'Verwijderen',
            onConfirm: close => {
                router.delete(`/datahub-webhooks/${webhook.id}`, {
                    preserveScroll: true,
                    preserveState: true,
                });

                close();
            },
        });

    return (
        <Container>
            <Segment>
                <SegmentHeader
                    header={`Webhooks (${webhooks?.meta?.total || 0})`}
                >
                    {auth.permissions.includes('create datahub webhooks') && (
                        <Button
                            variant='primary'
                            as={Link}
                            href='/datahub-webhooks/create'
                        >
                            <PlusIcon className='size-5' />
                            Nieuwe webhook
                        </Button>
                    )}
                </SegmentHeader>
                <SegmentContent>
                    <Table striped>
                        <TableHeader>
                            <TableRow>
                                <TableHeaderCell>#</TableHeaderCell>
                                <TableHeaderCell>Event</TableHeaderCell>
                                <TableHeaderCell>URL</TableHeaderCell>
                                <TableHeaderCell textAlign='center'>
                                    Active
                                </TableHeaderCell>
                                <TableHeaderCell>Include</TableHeaderCell>
                                <TableHeaderCell>Fields</TableHeaderCell>
                                <TableHeaderCell>Created at</TableHeaderCell>
                                <TableHeaderCell />
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {webhooks?.meta?.total === 0 && (
                                <NoDataRow numberOfColumns={8} />
                            )}

                            {webhooks?.data?.map(webhook => (
                                <TableRow key={webhook.id}>
                                    <TableCell>{webhook.id}</TableCell>
                                    <TableCell>{webhook.event}</TableCell>
                                    <TableCell>{webhook.url}</TableCell>
                                    <TableCell textAlign='center'>
                                        {webhook?.active ? (
                                            <CheckIcon className='inline-flex size-4 text-green-600' />
                                        ) : (
                                            <XMarkIcon className='inline-flex size-4 text-red-600' />
                                        )}
                                    </TableCell>
                                    <TableCell>{webhook.include}</TableCell>
                                    <TableCell>{webhook.fields}</TableCell>
                                    <TableCell>
                                        {localDate(webhook.created_at)}
                                    </TableCell>
                                    <TableCell textAlign='right'>
                                        {[
                                            'update datahub webhooks',
                                            'delete datahub webhooks',
                                        ]?.some(perm =>
                                            auth?.permissions?.includes(perm)
                                        ) && (
                                            <Menu>
                                                <MenuButton>
                                                    <EllipsisVerticalIcon className='size-5' />
                                                </MenuButton>
                                                <MenuItems anchor='bottom end'>
                                                    {auth?.permissions?.includes(
                                                        'update datahub webhooks'
                                                    ) && (
                                                        <MenuItem
                                                            as={Link}
                                                            href={`/datahub-webhooks/${webhook.id}/edit`}
                                                            icon={PencilIcon}
                                                        >
                                                            Wijzigen
                                                        </MenuItem>
                                                    )}
                                                    {auth?.permissions?.includes(
                                                        'delete datahub webhooks'
                                                    ) && (
                                                        <MenuItem
                                                            className='text-red-600'
                                                            onClick={() =>
                                                                confirmDelete(
                                                                    webhook
                                                                )
                                                            }
                                                            icon={TrashIcon}
                                                        >
                                                            Verwijderen
                                                        </MenuItem>
                                                    )}
                                                </MenuItems>
                                            </Menu>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </SegmentContent>

                <SegmentFooter>
                    <CustomPagination
                        meta={webhooks?.meta}
                        only={['webhooks']}
                    />
                </SegmentFooter>
            </Segment>
        </Container>
    );
};

export default WebhooksIndexView;
